import {MULTIPLE_CHOICE_QUESTIONS, PROBLEM_SOLVING} from '../constants/PagesNumberConstant';
import {getMaxLimit} from "../components/fields/CountField";

export const getSeconds = h => h * 60 * 60;

export function getIsShowMap(values, options, balance) {
    const deadline = Number(values.exactDeadline || 0);
    const spacing = values.spacing;
    const typeOfPaper = values.typeOfPaper;
    const page = values.page || 0;
    const slide = values.slide || 0;

    const freePlagiarismReport = values.freePlagiarismReport === 1;
    const freeAbstractPage     = values.freeAbstractPage === 1;
    const freeEditorCheck      = values.freeEditorCheck === 1;
    const freeVipSupport       = values.freeVipSupport === 1;

    const plagiarismReport     = values.plagiarismReport === 1;
    const abstractPage         = values.abstractPage === 1;
    const editorCheck          = values.editorCheck === 1;
    const vipSupport           = values.vipSupport === 1;

    let balancePlagiarismReport = balance && balance.plag_count > 0;
    let balanceAbstractPage = balance && balance.abs_page_count > 0;
    let balanceEditorCheck = balance && balance.editor_count > 0;

    const isShowMap = {
        page: false,
        slide: false,
        problem: false,
        question: false,
        visualPiece: false,
        spacing: false,
        pageValid: false,
        vipSupport: false,
        freeVipSupport: false,
        plagiarismReport: false,
        abstractPage: false,
        editorCheck: false,
        freeAbstractPage: false,
        freePlagiarismReport: false,
        freeEditorCheck: false,
        paperFormat: false,
        source: false
    };

    const enabled = page > 0 && !!typeOfPaper;

    isShowMap.spacing = enabled;
    isShowMap.pageValid = enabled;
    isShowMap.vipSupport = !freeVipSupport;
    isShowMap.plagiarismReport = enabled && !freePlagiarismReport;
    isShowMap.abstractPage = enabled && !freeAbstractPage;
    isShowMap.editorCheck = enabled && !freeEditorCheck;
    isShowMap.freeVipSupport = !vipSupport;
    isShowMap.freeAbstractPage = balanceAbstractPage && enabled && !abstractPage;
    isShowMap.freePlagiarismReport = balancePlagiarismReport && enabled && !plagiarismReport;
    isShowMap.freeEditorCheck = balanceEditorCheck && enabled && !editorCheck;
    isShowMap.paperFormat = enabled;
    isShowMap.source = page > 0 || slide > 0;

    if (typeOfPaper === MULTIPLE_CHOICE_QUESTIONS) {
        isShowMap.question = true;
    } else if (typeOfPaper === PROBLEM_SOLVING) {
        isShowMap.page = true;
        isShowMap.problem = true;
        isShowMap.visualPiece = true;
    } else if (typeOfPaper) {
        isShowMap.page = true;
        isShowMap.slide = true;
        isShowMap.problem = true;
        isShowMap.visualPiece = true;
    }

    const fields = ['page', 'slide', 'problem', 'visualPiece', 'source'];

    for (const field of fields) {
        if (!isShowMap[field]) continue;

        const value = Number(values[field] || 0);
        const max = getMaxLimit(field, deadline, spacing, typeOfPaper, value, values, options);
        const min = (options && options[field] && options[field].min) || 0;

        const canIncrement = value < max;
        const canDecrement = value > min;

        if (!canIncrement && !canDecrement) {
            isShowMap[field] = false;
        }
    }

    return isShowMap;
}
